/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import * as React from "react";
// import { Panel } from '@partnercenter-react/ui-webcore';
import { LocalizationContext } from "../../context/LocalizationContext";
import { LocalizationInfo } from "@emt/emt-localization/lib/localization-info";
import { EnrollmentDetail } from "../../containers/base-container";
import { RoutesHelper } from "../../utilities/routesHelper";
import button  from "@harmony/enablers/components/button/button";
import { createScope }  from "@harmony/enablers/react/scope-for-react";
import partnerCenterTheme  from "@harmony/enablers/themes/partner-center";
import flyInPanel  from "@harmony/enablers/components/fly-in-panel/fly-in-panel";

export interface EnrollmentBankAndTaxPanelProps {
  visible: boolean;
  isLoading: boolean;
  invitationDetail: EnrollmentDetail;
}

export interface EnrollmentBankAndTaxPanelbackProps {
  onClose: () => void;
  onContinue: () => void;
}

const scope = createScope({
  reactInstance: React,
  styles: [partnerCenterTheme],
});

const FlyInPanel = scope.forReact(flyInPanel);
const Button = scope.forReact(button);

type EnrollmentBankAndTaxPanelPropsType = EnrollmentBankAndTaxPanelProps &
  EnrollmentBankAndTaxPanelbackProps;

export class EnrollmentBankAndTaxPanel extends React.Component<EnrollmentBankAndTaxPanelPropsType> {
  private programNameNoSpace: string = "";

  constructor(props: EnrollmentBankAndTaxPanelPropsType) {
    super(props);
  }

  render(): JSX.Element {
    return (
      <LocalizationContext.Consumer>
        {(localization) => this.renderContent(localization)}
      </LocalizationContext.Consumer>
    );
  }

  private renderContent(localization: LocalizationInfo) {
    if (!this.props.invitationDetail) {
      return null;
    }

    this.programNameNoSpace = this.props.invitationDetail.programName.replace(
      /\s+/g,
      ""
    );

    return (
      <FlyInPanel
        style={{ "--size": "var(--he-panel-size-small)" }}
        open={this.props.visible}
        onHeAfterHide={this.props.onClose}
      >
        <div slot="heading" style={{ marginTop: 100 }}>
          <strong>
            {localization.format(
              "EnrollInHeading",
              this.props.invitationDetail.programName
            )}
          </strong>
        </div>
        <div>
          <p className="spacer-xxs-top spacer-md-bottom">
            {this.props.invitationDetail.locationName} (
            {this.props.invitationDetail
              ? `${this.props.invitationDetail.partnerId.type}: ${this.props.invitationDetail.partnerId.value}`
              : ""}
            )<br />
            {this.props.invitationDetail.invitationOfferingTimeline
              ? this.props.invitationDetail.invitationOfferingTimeline.name
              : ""}
          </p>
          <div>
            <p>
              {this.transformTextWithBoldDetails(
                localization.strings["BankAndTaxModalDescriptionText1"]
              )}
            </p>
          </div>

          <div>
            <p>{localization.strings["BankAndTaxModalDescriptionText2"]}</p>
          </div>
        </div>

        <div slot="footer">
          <div className="spacer-xs-top" style={{ display: "flex", gap: 10 }}>
            <Button
              type="submit"
              appearance="primary"
              external
              onClick={() => this.props.onContinue()}
              href={RoutesHelper.getBankAndTaxRoute(
                this.props.invitationDetail.partnerId.value +
                  "_" +
                  this.props.invitationDetail.offeringGuid
              )}
              target="_blank"
              data-bi-slot="1"
              data-bi-id={"BankAndTaxContinue-" + this.programNameNoSpace}
            >
              {localization.strings["AddBankAndTaxButtonText"]}
            </Button>
            <Button
              type="reset"
              appearance="secondary"
              onClick={() => this.props.onClose()}
              data-bi-slot="2"
              data-bi-id={"BankAndTaxModalClose-" + this.programNameNoSpace}
            >
              {localization.strings["CancelModalText"]}
            </Button>
          </div>
        </div>
      </FlyInPanel>
    );
  }

  private transformTextWithBoldDetails(text: string): JSX.Element {
    if (!text) {
      return <></>;
    }
    const splitText = text.split("<b>");
    if (splitText.length < 2) {
      return <>{text}</>;
    }

    const boldText = splitText[1].split("</b>");
    if (boldText.length < 2) {
      return <>{text}</>;
    }

    return (
      <>
        {splitText[0]}
        <strong>{boldText[0]}</strong>
        {boldText[1]}
      </>
    );
  }
}
